import React from "react";
import { overlayBase, useParticles } from "./_shared";

interface Props {
  /** Number of spark dots, default 8 */
  count?: number;
  /** Spark colour, default electric yellow */
  color?: string;
}

/**
 * SparkFlicker — quick opacity flicker on small spark dots.
 * Great for electrician / electrical service banners.
 */
const SparkFlicker: React.FC<Props> = ({
  count = 8,
  color = "#ffd75e",
}) => {
  const parts = useParticles(
    count,
    (i, r) => ({
      id: i,
      left: 20 + r(0) * 60,
      top: 15 + r(1) * 60,
      delay: r(2) * 2,
      d: 0.15 + r(3) * 0.25,
    }),
    [count]
  );

  return (
    <div style={overlayBase}>
      <style>{`
        @keyframes oot-spark {
          0%, 80%, 100% { opacity: 0;   transform: scale(0.6); }
          85%            { opacity: 1;   transform: scale(1.3); }
          92%            { opacity: 0.4; }
        }
      `}</style>
      {parts.map((p) => (
        <div
          key={p.id}
          style={{
            position: "absolute",
            left: `${p.left}%`,
            top: `${p.top}%`,
            width: 4,
            height: 4,
            borderRadius: "50%",
            background: color,
            boxShadow: `0 0 6px 2px ${color}`,
            animation: `oot-spark ${p.d + 1.5}s steps(1) ${p.delay}s infinite`,
          }}
        />
      ))}
    </div>
  );
};

export default SparkFlicker;
